import React from 'react'

// import Slide from './slide'

// import { container } from '../../styles/components/container.module.scss';
import Styles from '../../styles/components/slider.module.scss'
const { svg, container } = Styles

class Slider extends React.Component {
  constructor(props) {
    super(props)
    this.svg = null
  }

  componentDidMount() {
    require.ensure(
      ['./svg'],
      () => {
        this.svg = require('./svg')
        this.forceUpdate()
      },
      'slider-async-chunk'
    )
  }

  render() {
    return (
      <section className={Styles.slider}>
        {this.svg ? (
          <this.svg slides={this.props.slides} />
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            className={svg}
            version="1.1"
            viewBox="0 0 1920.1 1080.2"
            preserveAspectRatio="xMidYMid slice"
            width="100%"
            height="1000"
          >
            <rect
              backgroundColor={this.props.slides[0].image.bgColor}
              x="0"
              y="0"
              width="1920.1"
              height="1080.2"
            />
            {/* <Slide index={0} {...this.props.slides[0]} /> */}
          </svg>
        )}
      </section>
    )
  }
}

export default Slider



// WEBPACK FOOTER //
// ./src/components/slider/slider.js